"use strict";

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default() {
  return {
    name: 'or',
    synopsis: 'or [CONDITION1] [CONDITION2]',
    description: 'Evaluate the OR of two conditions to a boolean',
    execute: function execute(_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          condition1 = _ref2[0],
          condition2 = _ref2[1];

      return condition1 || condition2;
    }
  };
};

exports.default = _default;